<template>
    <main class="FlashmaniaView-MAIN DISPLAY">
    <main class="INNER-MARGIN">

        <!-- banner -->
        <div ref="sliderBanner" class="general-slider sliderBanner">
            <a v-for="(item, index) in sliders.Banner.content" :key="index" :href="getFrontURL()+'/cupon/?cupon='+item.id">
                <img :src="item.banner_url">
            </a>
        </div>
        <div class="slider-buttons">
            <button
                v-for="(item, index) in sliders.Banner.content" :key="index"
                @click="setSliderIndex('Banner', index)"
                :class="`active-btn-${index == sliders.Banner.current}`"
            >
            </button>
        </div>

        <section class="section-cupones-flash">
            <h3>Cupones Flash</h3>
            <p>¡Ofertas por tiempo limitado!</p>
            <div class="cupones-flash">
                <a v-for="(item, index) in sliders.Flash.content" :key="index" :href="getFrontURL()+'/cupon/?cupon='+item.id">
                    <img :src="item.url_banner">
                </a>
                <a v-for="(item, index) in sliders.Flash.content" :key="index" :href="getFrontURL()+'/cupon/?cupon='+item.id">
                    <img :src="item.url_banner">
                </a><!-- <- duplicado -->
            </div>
        </section>

        <br/>
        <br/>

    </main>
    </main>
</template>

<script>
export default {
    name: 'FlashmaniaView',
    data(){
        return{
            sliders: {
                Banner: {
                    content: [ // api lista
                        require('../assets/examples/banner-flash.png'),
                        require('../assets/examples/banner-flash.png'),
                        require('../assets/examples/banner-flash.png')
                    ],
                    current: 0,
                    interval: undefined,
                },
                Flash: {
                    content: [
                        require('../assets/examples/sliderFlash.png'),
                        require('../assets/examples/sliderFlash.png'),
                        require('../assets/examples/sliderFlash.png'),
                        require('../assets/examples/sliderFlash.png'),
                        require('../assets/examples/sliderFlash.png'),
                        require('../assets/examples/sliderFlash.png'),
                    ],
                    current: 0,
                },
            },
            cupones: [],
        }
    },
    methods: {
        getFrontURL(){
			return window.location.origin;
		},

        async getBanners(){
            try {
                const response = await fetch("https://promo-colaboradores.ideeo.mx/api/banners", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        id: "1"
                    })
                });
                const result = await response.json();
                this.sliders.Banner.content = result.data;   
                this.startSlider('Banner');
            } catch (error) {
                console.error("Error en la solicitud:", error);
            }
        },

        async getCupones(id_, tipoCupon_){
            try {
                const response = await fetch("https://promo-colaboradores.ideeo.mx/api/cupones", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        id: id_.toString(),
                        tipo_cupon: tipoCupon_.toString(),
                    })
                });

                const result = await response.json();
                //console.log("Respuesta del servidor:", tipoCupon_, result.data);

                if(tipoCupon_ == 1){
                    this.cupones = result.data;
                }else
                if(tipoCupon_ == 2){
                    this.sliders.Flash.content = result.data;
                }else
                if(tipoCupon_ == 3){
                    this.sliders.Temporada.content = result.data;
                }
            } catch (error) {
                console.error("Error en la solicitud:", error);
            }
        },

        startSlider(slider_){
            const slider = this.$refs[`slider${slider_}`];
            const num = this.sliders[slider_].content.length;
            const w = slider.offsetWidth;
            
            setInterval(()=>{
                if(this.sliders[slider_].current >= num-1){
                    this.sliders[slider_].current = 0;
                }else{
                    this.sliders[slider_].current++;
                }
                slider.scroll(w*this.sliders[slider_].current, 0);        
            }, 4000);
        },

        setSliderIndex(slider_, index_){
            const slider = this.$refs[`slider${slider_}`];
            const w = slider.offsetWidth;
            
            this.sliders[slider_].current = index_;
            slider.scroll(w*this.sliders[slider_].current, 0);
            console.log(index_, index_*this.sliders[slider_].current)
        },
    },
    mounted(){
        //this.startSlider('Banner');
        this.getBanners(); //borrar esto para regresar a los banners anteriores
        this.getCupones(1, 2);
    }
}
</script>

<style scoped>
.FlashmaniaView-MAIN{
    font-family: 'Benton Sans BBVA book';
    background-color: #ffefde7a;
}

/* slider Banner */
.sliderBanner a{
    min-width: 99.9%;
    width: 100%;
}

.sliderBanner img{
    min-width: 99.9%;
    width: 100%;
}

h3{
    font-weight: 200;
    color: white;
    background-color: #051283;
    width: fit-content;
    margin-left: auto;
    margin-right: auto;
    padding: 0 1ch;
}

section > p, .INNER-MARGIN > p{
    margin-top: -1.5ch;
    text-align: center;
}

.section-cupones-flash{
    background-color: #FFEFDE;
    border-radius: 1ch;
    padding: 2ch;
    padding-top: 0.5ch;
    margin-top: 3ch;
}

.cupones-flash{
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 1ch;
}

.cupones-flash img{
    width: 100%;
}

/* RESPONSIVE */
@media all and (max-width:780px){

    .cupones-flash{
        grid-template-columns: 1fr;
    }

}
</style>